/* eslint-disable no-console */
import { isStepOnPage } from '../utils/configuration-utils';

const updateProjectionUI = () => {
  if (!isStepOnPage('projection')) return;
  const selectedOption = document.querySelector('[name="projection"]:checked');
  const img = document.querySelector('.awning-projection-image img');
  if (selectedOption && img) {
    img.src = selectedOption.getAttribute('data-option-img');
  }
};

const updateProjectionUpgradeOptions = (state) => {
  if (!isStepOnPage('projection')) return;
  const {
    projectionUpgrade1,
    projectionUpgrade2,
    size,
  } = state;
  const upgrades = {
    projectionUpgrade1,
    projectionUpgrade2,
  };
  const upgradeSelector = 'upgrade-available';
  Object.keys(upgrades).forEach((key) => {
    const div = document.getElementById(key);
    if (size >= upgrades[key] && upgrades[key] !== '') {
      div.classList.add(upgradeSelector);
    } else {
      div.classList.remove(upgradeSelector);
    }
  });
};

export {
  updateProjectionUI,
  updateProjectionUpgradeOptions,
};
/* eslint-enable no-console */
